import React, { Component } from 'react';
import { OpenFileLink } from '../../../common/components/data-display';
import { t } from '../../../app/i18n';
import { selectToken } from '../../../features/auth/ducks';
import { connect } from 'react-redux';
import DatePicker from 'antd/lib/date-picker';
import moment from 'moment';


const { RangePicker, MonthPicker } = DatePicker;
const mapStateToProps = state => ({
  token: selectToken(state)
});

@connect(mapStateToProps)
export default class Exports extends Component {

  onChangeDate = key => (date) => {
    this.setState({
      ...this.state,
      [key]: date.toISOString(),
    });
  }

  constructor(props) {
    super(props);

    //oldest payment on prod is created on 2017-12-12, default start date is on 1st of that month
    const defaultFromDate = moment.utc("2017-12-01").format("YYYY-MM-DD") + "T00:00:00.000Z";
    this.state = {
      unpairedPayments: {
        from: defaultFromDate,
        to: moment.utc().endOf('day').toISOString()
      },
      unusedPayments: {
        from: defaultFromDate,
        to: moment.utc().endOf('day').toISOString()
      },
      profitMajak: {
        from: defaultFromDate,
        to: moment.utc().endOf('day').toISOString()
      },
      provisionFee: {
        from: defaultFromDate,
        to: moment.utc().endOf('day').toISOString()
      },
      earlyRepayment: {
        from: defaultFromDate,
        to: moment.utc().endOf('day').toISOString()
      },
      paymentsOverpayments: {
        from: defaultFromDate,
        to: moment.utc().endOf('day').toISOString()
      },
      sumView: moment.utc().toISOString(),
      detailedView: moment.utc().toISOString(),
      penaltyFees: {
        from: defaultFromDate,
        to: moment.utc().endOf('day').toISOString()
      },
      cardPayment: {
        from: defaultFromDate,
        to: moment.utc().endOf('day').toISOString()
      },
      insuranceDate: moment.utc().toISOString(),
      blacklist: {
        from: defaultFromDate,
        to: moment.utc().endOf('day').toISOString()
      },
      affiliateDate: moment.utc().toISOString(),
      utmData: {
        from: defaultFromDate,
        to: moment.utc().endOf('day').toISOString()
      }
    }
  }

  onFilterDateRangeChange = key => ([dateFrom, dateTo]) => {
    this.setState({
      [key]: {
        from: dateFrom ? dateFrom.startOf('day').toISOString() : "",
        to: dateTo ? dateTo.endOf('day').toISOString() : ""
      }
    });
  };

  render() {
    const {
      token,
    } = this.props;

    return (
      <div>
        {token && (
          <table>
            <tr>
              <td>Export zostatkov investorov:   </td>
              <td></td>
              <td>
                <OpenFileLink
                  isButton
                  href={`${process.env.REACT_APP_API_URL}/investment/reportInvestors?token=${token}`}
                >
                  {t('Export')}
                </OpenFileLink>
              </td>
            </tr><tr>
              <td>Export nespárovaných platieb v rozsahu:   </td>
              <td>
                <RangePicker
                  onChange={this.onFilterDateRangeChange('unpairedPayments')}
                  format="DD.MM.YYYY"
                  style={Object.assign({ marginRight: 15 })}
                  defaultValue={[moment.utc(this.state.unpairedPayments.from), moment.utc(this.state.unpairedPayments.to)]}
                /></td>
              <td><OpenFileLink
                isButton
                href={`${process.env.REACT_APP_API_URL}/investment/reportUnpairedPayments?token=${token}&datefrom=${this.state.unpairedPayments.from}&dateto=${this.state.unpairedPayments.to}`}
              >
                {t('Export')}
              </OpenFileLink></td>
            </tr><tr>
              <td>Export nepoužitých splátok v rozsahu:   </td>
              <td>
                <RangePicker
                  onChange={this.onFilterDateRangeChange('unusedPayments')}
                  format="DD.MM.YYYY"
                  style={Object.assign({ marginRight: 15 })}
                  defaultValue={[moment.utc(this.state.unusedPayments.from), moment.utc(this.state.unusedPayments.to)]}
                /></td>
              <td><OpenFileLink
                isButton
                href={`${process.env.REACT_APP_API_URL}/investment/reportUnusedPayments?token=${token}&datefrom=${this.state.unusedPayments.from}&dateto=${this.state.unusedPayments.to}`}
              >
                {t('Export')}
              </OpenFileLink></td>
            </tr>

            {/*<tr>*/}
            {/*  <td>Export zisku Maják.sk v rozsahu:   </td>*/}
            {/*  <td><RangePicker*/}
            {/*    onChange={this.onFilterDateRangeChange('profitMajak')}*/}
            {/*    format="DD.MM.YYYY"*/}
            {/*    style={Object.assign({ marginRight: 15 })}*/}
            {/*    defaultValue={[moment.utc(this.state.profitMajak.from), moment.utc(this.state.profitMajak.to)]}*/}
            {/*  /></td>*/}
            {/*  <td><OpenFileLink*/}
            {/*    isButton*/}
            {/*    href={`${process.env.REACT_APP_API_URL}/investment/reportProfitMajak?token=${token}&datefrom=${this.state.profitMajak.from}&dateto=${this.state.profitMajak.to}`}*/}
            {/*  >*/}
            {/*    {t('Export')}*/}
            {/*  </OpenFileLink></td>*/}
            {/*</tr>*/}

            <tr>
              <td>Export poplatkov za poskytnutie v rozsahu:   </td>
              <td><RangePicker
                onChange={this.onFilterDateRangeChange('provisionFee')}
                format="DD.MM.YYYY"
                style={Object.assign({ marginRight: 15 })}
                defaultValue={[moment.utc(this.state.provisionFee.from), moment.utc(this.state.provisionFee.to)]}
              /></td>
              <td><OpenFileLink
                isButton
                href={`${process.env.REACT_APP_API_URL}/investment/reportProvisionFee?token=${token}&datefrom=${this.state.provisionFee.from}&dateto=${this.state.provisionFee.to}`}
              >
                {t('Export')}
              </OpenFileLink></td>
            </tr><tr>
              <td>Export poplatkov za predčasné splatenie v rozsahu:   </td>
              <td><RangePicker
                onChange={this.onFilterDateRangeChange('earlyRepayment')}
                format="DD.MM.YYYY"
                style={Object.assign({ marginRight: 15 })}
                defaultValue={[moment.utc(this.state.earlyRepayment.from), moment.utc(this.state.earlyRepayment.to)]}
              /></td>
              <td><OpenFileLink
                isButton
                href={`${process.env.REACT_APP_API_URL}/investment/reportEarlyRepaymentFee?token=${token}&datefrom=${this.state.earlyRepayment.from}&dateto=${this.state.earlyRepayment.to}`}
              >
                {t('Export')}
              </OpenFileLink></td>
            </tr>
            <tr>
              <td>Export splátok a nepoužitých platieb a preplatkov v rozsahu:   </td>
              <td>
                <RangePicker
                  onChange={this.onFilterDateRangeChange('paymentsOverpayments')}
                  format="DD.MM.YYYY"
                  style={Object.assign({ marginRight: 15 })}
                  defaultValue={[moment.utc(this.state.paymentsOverpayments.from), moment.utc(this.state.paymentsOverpayments.to)]}
                />
              </td>
              <td>
                <OpenFileLink
                  isButton
                  href={`${process.env.REACT_APP_API_URL}/investment/reportPaymentsOverpayments?token=${token}&datefrom=${this.state.paymentsOverpayments.from}&dateto=${this.state.paymentsOverpayments.to}`}
                >
                  {t('Export')}
                </OpenFileLink>
              </td>
            </tr><tr>
              <td>Mesačný rekonciliačný export transakcií (Detailný prehľad):   </td>
              <td>
                <MonthPicker
                  onChange={this.onChangeDate('detailedView')}
                  picker="month"
                  format="MM.YYYY"
                  style={Object.assign({ marginRight: 15 }, { marginLeft: 15 }, { float: 'right' })}
                  defaultValue={moment.utc(this.state.detailedView)}
                /></td>
                <td>
                  <OpenFileLink
                    isButton
                    href={`${process.env.REACT_APP_API_URL}/transactions/reconciliationReportDetail?token=${token}&date=${this.state.detailedView}`}
                    classNames="primary"
                  >
                  {t('Export')}
                  </OpenFileLink></td>
            </tr><tr>
              <td>Mesačný rekonciliačný export transakcií (Sumárny prehľad):   </td>
              <td>
                <MonthPicker
                  onChange={this.onChangeDate('sumView')}
                  picker="month"
                  format="MM.YYYY"
                  style={Object.assign({ marginRight: 15 }, { marginLeft: 15 }, { float: 'right' })}
                  defaultValue={moment.utc(this.state.sumView)}
              /></td>
              <td>
                <OpenFileLink
                  isButton
                  href={`${process.env.REACT_APP_API_URL}/transactions/reconciliationReportSummary?token=${token}&date=${this.state.sumView}`}
                  classNames="primary"
                >
                  {t('Export')}
                </OpenFileLink></td>
            </tr><tr>
              <td>Export sankčných poplatkov v rozsahu:   </td>
              <td>
              <RangePicker
                  onChange={this.onFilterDateRangeChange('penaltyFees')}
                  format="DD.MM.YYYY"
                  style={Object.assign({ marginRight: 15 })}
                  defaultValue={[moment.utc(this.state.penaltyFees.from), moment.utc(this.state.penaltyFees.to)]}
                /></td>
              <td>
                <OpenFileLink
                  isButton
                  href={`${process.env.REACT_APP_API_URL}/penalty-fees/reportPenaltyFees?token=${token}&datefrom=${this.state.penaltyFees.from}&dateto=${this.state.penaltyFees.to}`}

                >
                  {t('Export')}
                </OpenFileLink></td>
            </tr><tr>
              <td>Export zrážok zo mzdy:</td>
              <td>              </td>
              <td>
                <OpenFileLink
                  isButton
                  href={`${process.env.REACT_APP_API_URL}/loan/reportPayrollDeductions?token=${token}`}
                >
                  {t('Export')}
                </OpenFileLink></td>
            </tr><tr>
              <td>Export platieb kartou v rozsahu:   </td>
              <td>
              <RangePicker
                  onChange={this.onFilterDateRangeChange('cardPayment')}
                  format="DD.MM.YYYY"
                  style={Object.assign({ marginRight: 15 })}
                  defaultValue={[moment.utc(this.state.cardPayment.from), moment.utc(this.state.cardPayment.to)]}
                /></td>
              <td>
                <OpenFileLink
                  isButton
                  href={`${process.env.REACT_APP_API_URL}/payment/reportCardPayment?token=${token}&datefrom=${this.state.cardPayment.from}&dateto=${this.state.cardPayment.to}`}

                >
                  {t('Export')}
                </OpenFileLink></td>
            </tr>
            <tr>
              <td>Export do poistovne: </td>
              <td>
                <MonthPicker
                  disabled={false}
                  onChange={this.onChangeDate('insuranceDate')}
                  picker="month"
                  format="MM.YYYY"
                  style={Object.assign({ marginRight: 15 }, { marginLeft: 15 }, { float: 'right' })}
                  defaultValue={moment.utc(this.state.insuranceDate)}
                />
              </td>
              <td>
                <OpenFileLink
                  isButton
                  href={`${process.env.REACT_APP_API_URL}/loan/insuranceExport?token=${token}&date=${this.state.insuranceDate}`}
                >
                  {t('Export')}
                </OpenFileLink></td>
            </tr><tr>
              <td>Export klientov cez Affiliate: </td>
              <td>
                <MonthPicker
                  disabled={false}
                  onChange={this.onChangeDate('affiliateDate')}
                  picker="month"
                  format="MM.YYYY"
                  style={Object.assign({ marginRight: 15 }, { marginLeft: 15 }, { float: 'right' })}
                  defaultValue={moment.utc(this.state.affiliateDate)}
                />
            </td>
              <td>
                <OpenFileLink
                  isButton
                  href={`${process.env.REACT_APP_API_URL}/account/reportAffiliate?token=${token}&date=${this.state.affiliateDate}`}
                >
                  {t('Export')}
                </OpenFileLink></td>
            </tr><tr>
              <td>Export klientov v Blackliste:   </td>
              <td>
              <RangePicker
                  onChange={this.onFilterDateRangeChange('blacklist')}
                  format="DD.MM.YYYY"
                  style={Object.assign({ marginRight: 15 })}
                  defaultValue={[moment.utc(this.state.blacklist.from), moment.utc(this.state.blacklist.to)]}
                /></td>
              <td>
                <OpenFileLink
                  isButton
                  href={`${process.env.REACT_APP_API_URL}/account/reportBlackList?token=${token}&datefrom=${this.state.blacklist.from}&dateto=${this.state.blacklist.to}`}

                >
                  {t('Export')}
                </OpenFileLink></td>
            </tr>
            <tr>
              <td>Export pôžičiek s UTM parametrami:   </td>
              <td>
              <RangePicker
                  onChange={this.onFilterDateRangeChange('utmData')}
                  format="DD.MM.YYYY"
                  style={Object.assign({ marginRight: 15 })}
                  defaultValue={[moment.utc(this.state.utmData.from), moment.utc(this.state.utmData.to)]}
                /></td>
              <td>
                <OpenFileLink
                  isButton
                  href={`${process.env.REACT_APP_API_URL}/loan/reportUtm?token=${token}&datefrom=${this.state.utmData.from}&dateto=${this.state.utmData.to}&utm=${true}`}

                >
                  {t('Export')}
                </OpenFileLink></td>
            </tr>


          </table>

        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/admin/components/exports.js